import React from 'react';

interface IcoCrownProps {
    size?: number;
}

export const IcoCrown: React.FC<IcoCrownProps> = ({ size = 35 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${size / 1.1} ${size / 1.1}`} width={size} height={size}>
                <g fill="none">
                    <path
                        fill="#F1F1F1"
                        d="M20.643 11.65 16.87 4.99a1 1 0 0 0-1.74 0l-3.773 6.658a2 2 0 0 1-2.642.806l-4.301-2.169a1 1 0 0 0-1.383 1.25A82.237 82.237 0 0 1 7.248 26.5a2.79 2.79 0 0 0 2.74 2.301H22.01a2.79 2.79 0 0 0 2.74-2.3 82.295 82.295 0 0 1 4.218-14.964.998.998 0 0 0-1.383-1.25l-4.301 2.169a2 2 0 0 1-2.642-.806z"
                    />
                    <path
                        fill="#7E8487"
                        d="M23.68 24.576H8.32a2.104 2.104 0 0 0-2.095 2.112c0 1.166.939 2.112 2.095 2.112h15.36a2.104 2.104 0 0 0 2.095-2.112 2.104 2.104 0 0 0-2.095-2.112z"
                    />
                </g>
            </svg>
        </div>
    );
};
